module.exports = __webpack_public_path__ + "img/cl.b51cf61c.svg";